import Generator from './generator';

export default class ScreeningCurveGenerator extends Generator {
  static _lineChartConfig = {
    yAxis: 1,
    type: 'line',
    dashStyle: null,
    showInLegend: true,
    enableMouseTracking: true,
    customTags: ['screening'],
  };

  getScreeningSeriesData(objectArray) {
    const screeningSeriesData = this._getSeriesData(
      objectArray,
      'actualSubjectsScreenedCum',
    );

    return screeningSeriesData;
  }

  getSeries(objectArray) {
    const lineSeriesData = this.getScreeningSeriesData(objectArray);

    const screeningSeries = {
      id: 'screening',
      name: 'Screening (Actual)',
      data: lineSeriesData,
      color: '#3270A2',
      zIndex: 3,
      marker: { enabled: lineSeriesData.length === 1 },
      ...ScreeningCurveGenerator._lineChartConfig,
    };

    return [screeningSeries];
  }
}
